import type { common as commonEn } from '../en/common';

export const common: typeof commonEn = {
  appName: 'First Weeks',
  practiceTagline: 'Una aplicación de Families First Pediatrics',

  tabs: {
    home: 'Inicio',
    track: 'Registrar',
    history: 'Historial',
    guide: 'Guía',
  },

  actions: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    done: 'Listo',
    back: 'Atrás',
    next: 'Siguiente',
    skip: 'Omitir',
    start: 'Iniciar',
    stop: 'Detener',
    settings: 'Configuración',
    confirmDelete: '¿Eliminar este registro?',
  },

  eventTypes: {
    feed: 'Alimentación',
    diaper: 'Pañal',
    weight: 'Peso',
    pump: 'Extracción',
    sleep: 'Sueño',
  },

  sides: {
    left: 'Izquierdo',
    right: 'Derecho',
    both: 'Ambos',
  },

  contents: {
    breastmilk: 'Leche materna',
    formula: 'Fórmula',
    mixed: 'Mixta',
  },

  time: {
    justNow: 'Ahora mismo',
    agoHM: (h: number, m: number) => (h > 0 ? `hace ${h}h ${m}m` : `hace ${m}m`),
    durationHM: (h: number, m: number) => (h > 0 ? `${h}h ${m}m` : `${m} min`),
    today: 'Hoy',
    yesterday: 'Ayer',
    dayOfLife: (day: number) => `Día ${day}`,
  },

  sync: {
    idle: 'Sincronizado',
    syncing: 'Sincronizando…',
    offline: 'Sin conexión; se sincronizará al reconectar',
    unpaired: 'No conectado con su pareja',
    error: 'No se pudo conectar con el servicio de sincronización',
    loggedByPartner: 'Registrado por su pareja',
    loggedByMom: 'Registrado por mamá',
  },

  disclaimer:
    'Esta aplicación es para llevar registros y aprender. No es consejo médico y no reemplaza la atención de su pediatra ni del equipo de lactancia. Si le preocupa su bebé, llame al consultorio.',
  emergencyNote: 'Si es una emergencia, llame al 911.',

  loading: 'Cargando…',
};
